import { GraphEdge } from '../../../models/GraphEdge.interface';
import { GraphNode } from '../../../models/GraphNode.interface';
import { FilterableProperty } from './FilterableProperty';


export type VariableFilterComparator = 'lte' | 'gte' | 'between';



export abstract class BaseFilterState {
    constructor(
        public property: FilterableProperty
        ) {

    }

    public shouldInclude(element: GraphNode | GraphEdge): boolean {
        throw new Error('Not implemented');
    }

    isEqual(other: BaseFilterState): boolean {
        if (other.property.key !== this.property.key) {
            return false;
        }
        return JSON.stringify(this) === JSON.stringify(other);
    }
}

export class SingleFilterState extends BaseFilterState {
    constructor(
        public property: FilterableProperty,
        public comparator: 'lte' | 'gte',
        public value: number, 
        ) {
            super(property);
    }

    public shouldInclude(element: GraphNode | GraphEdge): boolean {
        if (this.comparator === 'lte') {
            return element[this.property.variable] <= this.value;
        } else if (this.comparator === 'gte') {
            return element[this.property.variable] >= this.value;
        }
    }
}

export class DoubleFilterState extends BaseFilterState {
    constructor(
        public property: FilterableProperty,
        public comparator: 'between',
        public value: number[], 
        ) {
            super(property);
    }

    public shouldInclude(element: GraphNode | GraphEdge): boolean {
        return element[this.property.variable] >= this.value[0] && element[this.property.variable] <= this.value[1];
    }
}

